import baseUrl from '../../../baseUrl.js';
import download from 'downloadjs';
import { getParameter, getPermission, handleInput, showMessageError } from '../../../classes/functions';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './position.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import axios from 'axios';
import ProductsInput from '../../../components/Inputs/ProductsInput.js';
import { format } from 'date-fns';
import { RiArrowUpDownLine } from 'react-icons/ri';
import PaginationPage from '../../../components/BasePage/Pagination/index.js';
import SelectSearchable from '../../../components/Select/SelectSearchable/index.js';

export default function StockPosition(){
  const [list, setList] = useState([]);
  const [labels, setLabels] = useState([]);
  const [indexes, setIndexes] = useState([]);
  const [qtdePage, setQtdePage] = useState(100);
  const [limitPage, setLimitPage] = useState(0);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({
    client: {
      name: "",
      id: ""
    },
    lotFrom: "",
    lotUntil: "",
    palletFrom: "",
    palletUntil: "",
    productFrom: {label: "", value: ""},
    productUntil: {label: "", value: ""},
    warehouseFrom: {label: "", value: ""},
    warehouseUntil: {label: "", value: ""},
    addressesFrom: {label: "", value: ""},
    addressesUntil: {
      label: "",
      value: ""
    },
    zeroed: ""
  });
  const [itemForSorting, setItemForSorting] = useState('QUANTIDADE');
  const [sortingType, setSortingType] = useState('DESC');
  const [productsFrom, setProductsFrom] = useState([]);
  const [productsUntil, setProductsUntil] = useState([]);
  const [warehousesFrom, setWarehousesFrom] = useState([]);
  const [warehousesUntil, setWarehousesUntil] = useState([]);
  const [addressesFrom, setAddressesFrom] = useState([]);
  const [addressesUntil, setAddressesUntil] = useState([]);
  const [labelsByList, setLabelsByList] = useState([]);
  const [people, setPeople] = useState([]);
  const [features, setFeatures] = useState([]);
  const [carrying, setCarrying] = useState(true);

  function getParams(){
    let filtersParams = `clientes=${filters.client.id}&lote_from=${filters.lotFrom}&lote_to=${filters.lotUntil}&palete_to=${filters.palletUntil}&palete_from=${filters.palletFrom}&product_from=${filters.productFrom.value}&product_to=${filters.productUntil.value}&warehouse_from=${filters.warehouseFrom.value}&warehouse_to=${filters.warehouseUntil.value}&addresses_from=${filters.addressesFrom.value}&addresses_to=${filters.addressesUntil.value}&zeroed=${filters.zeroed}`
    features.map((feature, index) => {
      if(feature.controls_balance === "S"){
        if(filters[`${feature.fluxo}_to`]){
          filtersParams += `&${feature.fluxo}_to=${filters[`${feature.fluxo}_to`]}`;
        }

        if(filters[`${feature.fluxo}_from`]){
          filtersParams += `&${feature.fluxo}_from=${filters[`${feature.fluxo}_from`]}`;
        }
      }
    });

    return filtersParams;
  }
  
  function search () {
    api.get(`/api/stock_position/search?property=${itemForSorting}&sortingType=${sortingType}&page=${page}&limit=${qtdePage}&${getParams()}`)
    .then((response) => {
      setCarrying(false);
      setList(response.data.dados);
      setLabels(response.data.labels);
      setIndexes(response.data.indexes);
      setLimitPage(parseInt(response.data.total / qtdePage) + 1);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  function print () {
    setCarrying(true);

    axios.get(
      baseUrl + `api/stock_position/print?${getParams()}`, 
      {responseType: 'blob',
      headers: {
        empresa: localStorage.empresa,
        usuario: localStorage.usuario
      }}
    ).then((response) => {      
      const content = response.headers['content-type'];
      const dateAndHour = new Date();
      const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');

      download(response.data, `estoque ${formatedDateAndHour}.xlsx`, content)
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function associateLabelWithList(){
    let array = [];
    let newArray = [];

    list?.map((itemList) => {
      array.push(Object.entries(itemList));
    });

    array[0]?.map((object) => {
      labels?.map((label) => {
        if(newArray?.some((newObject) => newObject?.label === label)){
          return false;
        }

        if(object[0]?.replace(/[\s_.]/g, ' ')?.replace('id_', '').toLowerCase().includes(label?.toLowerCase().replace('id_', '').replace(/[\s_.]/g, ' '))){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'nome_produto' && label === 'DESCRIÇÃO'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'codigo_produto' && label === 'CÓD.'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'average_coast' && label === 'CUSTO MÉDIO' && getPermission("CADASTROS - CUSTO MEDIO")){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'total_coast' && label === 'CUSTO TOTAL' && getPermission("CADASTROS - CUSTO MEDIO")){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'quantidade' && label === 'QUANT.'){
          newArray?.push({label: label, item: object[0]});
        }
      });
    });

    setLabelsByList(newArray);
  }

  function getPeople(){
    api
    .get(`/api/people/getList`)
    .then((response) => {
      setPeople(response.data.row.map((person) => {
        return {label: person.nome_fantasia, value: person.id};
      }));
    })
    .catch((error) => {
      console.log(error?.response);
    });
  }

  function getProducts(value = "", name){
    api
    .get(`/api/products/getSearchProduct?term=${value}`)
    .then((response) => {
      let adaptedProductsListForSelect = [{label: "Selecione", value: ""}]; 
        
      response.data.list.map((data, index) => {
        if(((value?.length <= 2) && index <= 50) || value.length > 2){
          return adaptedProductsListForSelect.push({label: data.nome || `${data.codigo_produto} - ${data.descricao}`, value: data.codigo_produto});        
        }
      });
  
      if((name === "productFrom") || !name){
        setProductsFrom(adaptedProductsListForSelect);
      }
  
      if((name === "productUntil") || !name){
        setProductsUntil(adaptedProductsListForSelect);
      }
    })
    .catch((error) => {
      if(error?.response?.data){
        showMessageError(error.response.data);
      }
    });
  }
  
  function getFeatures(){
    api
    .get("/api/features/getList")
    .then((response) => {
      response.data.map((feature) => {
        setFilters((prevState) => ({
          ...prevState,
          [`${feature.fluxo}_from`]: "",
          [`${feature.fluxo}_to`]: ""
        }));
      });
      
      setFeatures(response.data);
    })
    .catch((error) => {
      console.log(error?.response);
      showMessageError(error?.response?.message);
    });
  }

  function getWarehouses(){
    setCarrying(true);

    api
    .get("/api/warehouses/getList")
    .then((response) => {
      let adaptedWarehousesListForSelect = [{label: "Selecione", value: ""}]; 

      response.data.map((data) => {
        adaptedWarehousesListForSelect.push({label: data.descricao, value: data.codigo_armazem});
      });

      setWarehousesFrom(adaptedWarehousesListForSelect);
      setWarehousesUntil(adaptedWarehousesListForSelect);

      setCarrying(false);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  function getAddresses(value = "", name){
    api
    .get(`/api/adresses/searchAdresses?term=${value}`)
    .then((response) => {
      let adaptedAddressesListForSelect = [{label: "Selecione", value: ""}]; 
  
      response.data.adresses.map((data, index) => {
        if((((value?.length <= 2) && index <= 50) || value.length > 2) && data.nome){
          return adaptedAddressesListForSelect.push({label: data.nome, value: data.nome});
        }
      });
  
      if((name === "addressesFrom") || !name){
        setAddressesFrom(adaptedAddressesListForSelect);
      }
        
      if((name === "addressesUntil") || !name){
        setAddressesUntil(adaptedAddressesListForSelect);
      }
    })
    .catch((error) => {
      console.log(error)
    });
  }

  useEffect(() => {
    search();
  }, [sortingType, itemForSorting, qtdePage, page]);

  useEffect(() => {
    associateLabelWithList();
  }, [list, labels]);

  useEffect(() => {
    getPeople();
    getFeatures();
    getWarehouses();
    getProducts();
    getAddresses();
  }, []);
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Posição de Estoque"></Title>
        <div className="container">
          <div className="containerGroupData">
            <h2>Filtros</h2>
            <hr></hr>   
            <div className="input-group">
              <div className="formDiv">
                <label>Armazém de</label><br/>
                <SelectSearchable options={warehousesFrom} state={filters.warehouseFrom} setState={setFilters} name="warehouseFrom" placeholder="Armazém De" isMulti={false} />
              </div>
              <div className="formDiv">
                <label>Armazém até</label><br/>
                <SelectSearchable options={warehousesUntil} state={filters.warehouseUntil} setState={setFilters} name="warehouseUntil" placeholder="Armazém Até" isMulti={false} />
              </div>
              <div className="formDiv">
                <label>Endereço de</label><br/>
                <SelectSearchable options={addressesFrom} state={filters.addressesFrom} setState={setFilters} getFunctionOnChange={getAddresses} name="addressesFrom" placeholder="Endereço Até" isMulti={false} />
              </div>
              <div className="formDiv">
                <label>Endereço até</label><br/>
                <SelectSearchable options={addressesUntil} state={filters.addressesUntil} setState={setFilters} getFunctionOnChange={getAddresses} name="addressesUntil" placeholder="Endereço Até" isMulti={false} />
              </div>
            </div>
            <div className="input-group">
            {getParameter("DEFINE_PALETE_SEP") &&
              <>
                <div className="formDiv">
                  <label>Etiqueta Palete De</label>
                  <input type="text" placeholder="Etiqueta Palete De" value={filters.palletFrom} onChange={(e) => setFilters((prevState) => ({...prevState, palletFrom: e.target.value}))} maxLength="75" />
                </div>
                <div className="formDiv">
                  <label>Etiqueta Palete Até</label>
                  <input type="text" placeholder="Etiqueta Palete Até" value={filters.palletUntil} onChange={(e) => setFilters((prevState) => ({...prevState, palletUntil: e.target.value}))} maxLength="75" />
                </div>
              </>
            }
            <div className="formDiv">
              <label>Produto De</label>
              <SelectSearchable options={productsFrom} state={filters.productFrom} setState={setFilters} getFunctionOnChange={getProducts} name="productFrom" placeholder="Produto De" isMulti={false} />
            </div>
            <div className="formDiv">
              <label>Produto Até</label>
              <SelectSearchable options={productsUntil} state={filters.productUntil} setState={setFilters} getFunctionOnChange={getProducts} name="productUntil" placeholder="Produto Até" isMulti={false} />
            </div>
            </div>
            <div className="input-group">
              {features.map((feature, index) => {
                if(feature.controls_balance === "S"){
                  return (
                    <>
                      <div className="formDiv" key={index}>
                        <label>{`${feature.descricao} De`}</label>
                        <input type="text" placeholder={`${feature.descricao} De`} value={filters[`${feature.fluxo}_from`]} onChange={(e) => setFilters((prevState) => ({...prevState, [`${feature.fluxo}_from`]: e.target.value}))} name={filters[`${feature.fluxo}_from`]} isMulti={false} />
                      </div>
                      <div className="formDiv" key={index + 1}>
                        <label>{`${feature.descricao} Até`}</label>
                        <input type="text" placeholder={`${feature.descricao} Até`} value={filters[`${feature.fluxo}_to`]} onChange={(e) => setFilters((prevState) => ({...prevState, [`${feature.fluxo}_to`]: e.target.value}))} name={filters[`${feature.fluxo}_to`]} isMulti={false} />
                      </div>
                    </>
                  )
                }
              })}
            </div>
            <div className="input-group">
              {getParameter("DEFINE_USUARIO_SEP") === "T" && <div className="formDiv">
                <label>Cliente</label>
                <SelectSearchable options={people} state={filters.people} setState={setFilters} name="people" placeholder="Cliente" isMulti={true} />
              </div>}
            </div>
            <div className="divGroup">
              <div className="formDiv">
                <label>Considera zerados</label><br/>
                <select value={filters.zeroed} onChange={ (e) => setFilters((prevState) => ({...prevState, zeroed: e.target.value}))} >
                  <option value="">Selecione</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </div>
              <div className="formDiv">
                <label>Itens por página</label><br/>
                <select value={qtdePage} onChange={(e) => {setQtdePage(e.target.value)}}>
                  <option>Itens por página</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="300">300</option>
                  <option value="400">400</option>
                  <option value="500">500</option>
                </select>
              </div>
              <div className="formDiv">
                <label>Lote De</label>
                <input type="text" placeholder="Lote de" value={filters.lotFrom} onChange={(e) => setFilters((prevState) => ({...prevState, lotFrom: e.target.value}))} maxLength="75" />
              </div>
              <div className="formDiv">
                <label>Lote Até</label>
                <input type="text" placeholder="Lote até" value={filters.lotUntil} onChange={(e) => setFilters((prevState) => ({...prevState, lotUntil: e.target.value}))} maxLength="75" />
              </div>
              <div className="formDiv">
                <label>&nbsp;</label><br/>
                <button className="buttonInsertMargin" onClick={search}>
                  Pesquisar
                </button> 
                {labels.length > 1 && <div>
                  <button className="buttonInsert" onClick={print}>
                    Imprimir
                  </button> 
                </div>}
              </div>
            </div>
          </div>
          <br/>
          <div>
            <div className="divGroup">
              <table className="stock-position">
                <thead className="stock-position__header">
                  <tr>
                    <th scope="col" className="stock-position___item">#</th>
                    {labelsByList?.map((label, index) => {
                      return (
                        <th className="stock-position___item" scope="col" key={index}>
                          <div>
                            <p>{label?.label}</p>
                            <button><RiArrowUpDownLine onClick={() => {sortingType === 'ASC' ? setSortingType('DESC') : setSortingType('ASC'); setItemForSorting(label?.item)}}  /></button>
                          </div>
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {list?.map((item, index)=>{
                    return(
                      <tr key={`${item.codigo_produto}-${index}`}>
                        <td scope="col">{index+1}</td>
                        {indexes.map((label, columnIndexIndex)=>{
                          return(
                            <td scope="col" key={columnIndexIndex + 1}>{item[label]}</td>
                          )
                        })}
                      </tr>
                    )
                  })}
                  {list?.length === 0 && <tr>
                    <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>}
                </tbody>
              </table>
            </div>
            <br/>
            <PaginationPage limit={limitPage} page={page} setPage={setPage} />
          </div>
        </div>
      </div>}
    </div>
  )
}